import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { API_BASE_URL } from './config';

function RegisterForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const key = query.get('key');

  const [presetEmail, setPresetEmail] = useState('');
  const [jobOptions, setJobOptions] = useState([]);
  const [industryOptions, setIndustryOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [purposeOptions, setPurposeOptions] = useState([]);
  const [formData, setFormData] = useState({
    password: '',
    password_confirm: '',
    last_name_kanji: '',
    first_name_kanji: '',
    last_name_alphabet: '',
    first_name_alphabet: '',
    birthday: '1990-10-16',
    gender: '',
    zip_current: '',
    address_current: '',
    amc: '',
    phone: '',
    job: '',
    city: '',
    industry: '',
    industry_other: '',
    purpose: [],
    purpose_other: '',
    purpose_detail: '',
    zip_second: '',
    address_second: '',
    condition_no_home: false,
    condition_not_single_transfer: false,
    condition_not_care: false,
  });

  const [errors, setErrors] = useState({});

  // ヘルパー: 必ず配列に変換
  const safeArray = (data) => Array.isArray(data) ? data : [];

  useEffect(() => {
    if (!key) {
      navigate('/email-auth');
      return;
    }

    fetch(`${API_BASE_URL}/v1/email/verify?key=${key}`)
      .then(res => {
        if (!res.ok) throw new Error('Not Found');
        return res.json();
      })
      .then(data => {
        if (data?.email) {
          setPresetEmail(data.email);
        } else {
          throw new Error('No email returned');
        }
      })
      .catch(() => {
        navigate('/email-auth');
      });

    // 職業形態
    fetch(`${API_BASE_URL}/v1/master/options?master_name=job`)
      .then(res => res.json())
      .then(data => setJobOptions(safeArray(data)))
      .catch(() => {
        console.error('job マスターの取得に失敗しました');
        setJobOptions([]);
      });

    // 業種
    fetch(`${API_BASE_URL}/v1/master/options?master_name=industry`)
      .then(res => res.json())
      .then(data => setIndustryOptions(safeArray(data)))
      .catch(() => {
        console.error('industry マスターの取得に失敗しました');
        setIndustryOptions([]);
      });

    // 希望二地域居住地域
    fetch(`${API_BASE_URL}/v1/master/denshijiti`)
      .then(res => res.json())
      .then(data => setCityOptions(safeArray(data)))
      .catch(() => {
        console.error('denshijiti マスターの取得に失敗しました');
        setCityOptions([]);
      });

    // 二拠点居住の目的
    fetch(`${API_BASE_URL}/v1/master/options?master_name=purpose`)
      .then(res => res.json())
      .then(data => setPurposeOptions(safeArray(data)))
      .catch(() => {
        console.error('purpose マスターの取得に失敗しました');
        setPurposeOptions([]);
      });

  }, [key, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const newPurpose = checked
        ? [...prev.purpose, value]
        : prev.purpose.filter(item => item !== value);

      return {
        ...prev,
        purpose: newPurpose,
        purpose_detail: value === '99' && !checked ? '' : prev.purpose_detail,
      };
    });
  };

  const handleZipSearch = (target) => {
    const zip = formData[target];
    if (!/^\d{7}$/.test(zip)) {
      setErrors(prev => ({ ...prev, [target]: '郵便番号は7桁の数字で入力してください' }));
      return;
    }

    fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip}`)
      .then(res => res.json())
      .then(data => {
        if (data.results && data.results.length > 0) {
          const result = data.results[0];
          const address = `${result.address1}${result.address2}${result.address3}`;
          const addressKey = target === 'zip_current' ? 'address_current' : 'address_second';
          setFormData(prev => ({
            ...prev,
            [addressKey]: address,
          }));
          setErrors(prev => ({ ...prev, [target]: undefined }));
        } else {
          setErrors(prev => ({ ...prev, [target]: '該当する住所が見つかりませんでした' }));
        }
      })
      .catch(() => {
        setErrors(prev => ({ ...prev, [target]: '住所検索に失敗しました' }));
      });
  };

  const validate = () => {
    const newErrors = {};
    const regex = {
      password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/,
      alphabet: /^[A-Za-z]+$/,
      zip: /^\d{7}$/,
      amc: /^\d{10}$/,
      phone: /^0\d{10}$/,
    };

    if (!formData.password) newErrors.password = 'パスワードは必須です';
    else if (!regex.password.test(formData.password)) newErrors.password = '8文字以上で英大文字・小文字・数字・記号を含めてください';

    if (formData.password_confirm !== formData.password) newErrors.password_confirm = 'パスワードが一致しません';
    if (!formData.last_name_kanji) newErrors.last_name_kanji = '姓（漢字）は必須です';
    if (!formData.first_name_kanji) newErrors.first_name_kanji = '名（漢字）は必須です';

    if (!formData.last_name_alphabet) newErrors.last_name_alphabet = '姓（英字）は必須です';
    else if (!regex.alphabet.test(formData.last_name_alphabet)) newErrors.last_name_alphabet = '英字のみで入力してください';

    if (!formData.first_name_alphabet) newErrors.first_name_alphabet = '名（英字）は必須です';
    else if (!regex.alphabet.test(formData.first_name_alphabet)) newErrors.first_name_alphabet = '英字のみで入力してください';

    if (!formData.birthday) newErrors.birthday = '生年月日は必須です';
    if (!formData.gender) newErrors.gender = '性別は必須です';

    if (!formData.zip_current) newErrors.zip_current = '郵便番号は必須です';
    else if (!regex.zip.test(formData.zip_current)) newErrors.zip_current = '郵便番号は7桁の数字で入力してください';

    if (!formData.address_current) newErrors.address_current = '住所は必須です';

    if (formData.amc && !regex.amc.test(formData.amc)) {
      newErrors.amc = 'ANAマイレージクラブお客様番号は10桁の数字で入力してください';
    }

    if (!formData.phone) newErrors.phone = '電話番号は必須です';
    else if (!regex.phone.test(formData.phone)) newErrors.phone = '正しい電話番号を入力してください';

    if (formData.industry === '99') {
      const detail = formData.industry_other.trim();
      if (!detail) {
        newErrors.industry_other = '「その他」の内容を入力してください';
      }
    }

    if (!formData.city) newErrors.city = '希望自治体を選択してください';

    if (!formData.purpose || formData.purpose.length === 0) {
      newErrors.purpose = '二地域居住の目的を選択してください';
    }
    if (formData.purpose.includes('99')) {
      const detail = formData.purpose_other.trim();
      if (!detail) {
        newErrors.purpose_other = '「その他」の内容を入力してください';
      } else if (detail.length < 20 || detail.length > 80) {
        newErrors.purpose_other = '20文字以上80文字以内で入力してください';
      }
    }

    // if (!formData.purpose_detail) newErrors.purpose_detail = '具体的な目的は必須です';
    // else {
    //   const detail = formData.purpose_detail.trim();
    //   if (!detail) {
    //     newErrors.purpose_detail = '具体的な目的を入力してください';
    //   } else if (detail.length < 80 || detail.length > 200) {
    //     newErrors.purpose_detail = '80文字以上200文字以内で入力してください';
    //   }
    // }

    if (!formData.condition_no_home || !formData.condition_not_single_transfer || !formData.condition_not_care) {
      newErrors.conditions = '該当条件をすべてチェックしてください';
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validate();
    setErrors(newErrors);

    console.log('fetchbody', { ...formData, email: presetEmail });

    if (Object.keys(newErrors).length === 0) {
      const username = "2chiiki-prod";
      const password = "FJt.QqCaN.+3";
      const basicAuth = btoa(`${username}:${password}`);

      fetch(`${API_BASE_URL}/v1/user/register`, {
        method: 'POST',
        headers: {
           'Content-Type': 'application/json',
           'Authorization': `Basic ${basicAuth}`
        },
        
        body: JSON.stringify({ ...formData, email: presetEmail }),
      })
        .then(res => {
          if (!res.ok) throw new Error('登録に失敗しました');
          return res.json();
        })
        .then(data => {
          console.log('API response', data);
          alert('登録が完了しました');
          navigate('/login');
        })
        .catch(err => {
          alert(err.message);
        });
    }
  };

  const errorMsg = (field) => errors[field] && <div className="text-danger small">{errors[field]}</div>;

  return (
    <div className="container">
      <h2 className="mt-5">会員情報登録</h2>
      <form onSubmit={handleSubmit} className="mt-3">
        {/* ここに input/select 群（省略） */}
      </form>
    </div>
  );
}

export default RegisterForm;
